import { ApolloProvider } from '@apollo/client';
import { AuthProvider } from '../hooks/useAuth';
import { Box, } from '@chakra-ui/react'
import { ChakraProvider } from '@chakra-ui/react'
import Fonts from './fonts';
import Footer from '../Footer/Footer'
import  Header  from '../Header/Header'
import {Helmet} from 'react-helmet';
import React from 'react'
import Seo from './Seo';
import { client } from '../../../lib/apolloClient'
import styled from 'styled-components';
import theme from '../../theme/theme'

const Div = styled.div`

    animation: fadeInAnimation ease .8s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;

    @keyframes fadeInAnimation {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`
const Layout = ({ children }: LayoutProps) => {
    
    // if (typeof window !== 'undefined') {
    //     window.dataLayer = window.dataLayer || [];
    //     function gtag(){window.dataLayer.push(arguments);}
    //     gtag('js', new Date());
    //     gtag('config', 'G-YZKZW49506');
    // }
                    
    return (
        <Div>
            <Helmet>
                <meta property="og:image" content="/images/slide-1.jpg" data-react-helmet="true" />
                <script async src='https://www.googletagmanager.com/gtag/js?id=G-YZKZW49506'> </script> 
                <meta name="facebook-domain-verification" content="on4b77ecesf3fsh86le77r1pupxepu" data-react-helmet="true"/>
                (<noscript>{'<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MV9RQ57" height="0" width="0" style="display:none;visibility:hidden"></iframe>'}</noscript>)
                (<noscript>{'<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=838054284282452&ev=PageView&noscript=1"/>'}</noscript>)

                <script dangerouslySetInnerHTML={{__html: `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=838054284282452&ev=PageView&noscript=1"/>`}}></script>
            </Helmet>

            <Seo/>
            <ApolloProvider client={client}>
                {/* <AuthProvider> */} 
                    <ChakraProvider theme={theme}>
                    <Fonts/>
                    <Header /> 
                        <Box as='main' background='gray.50' position='relative'>{children}</Box>
                    <Footer></Footer>
                    </ChakraProvider>
                {/* </AuthProvider> */}
            </ApolloProvider>
        </Div>
    )
}

type LayoutProps = {
    children: React.ReactNode;
}

export default Layout